export const LEFT_PANEL_MIN_SIZE = 430;
export const LEFT_PANEL_MAX_SIZE = 569;
